import styled from "styled-components";

export const CheckoutContainer = styled.div`
  width: 55%;
  min-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 50px auto 0;
  background-color: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  border-radius: 8px;
`;


export const Total = styled.span`
  margin-top: 30px;
  margin-left: auto;
  font-size: 36px;
  color: #333;
  font-weight: 600;
`;

